// -- Split menu -- //
function moveElement(elementSelector, targetSelectors) {
	const element = document.querySelector(elementSelector);
	const footer = document.querySelector('footer');

	if (!element) {
		console.error(`Prvek ${elementSelector} nebyl nalezen`);
		return;
	}

	let moved = false;

	for (const targetSelector of targetSelectors) {
		const target = document.querySelector(targetSelector);
		if (target) {
			target.insertAdjacentElement('afterend', element);
			moved = true;
			break;
		}
	}

	if (!moved && footer) {
		footer.insertAdjacentElement('beforebegin', element);
	}
}


//On funkce, na kliknutí a zavolání funkce
function on(eventType, selector, callback) {
	document.addEventListener(eventType, function (e) {
		let targetElement = e.target;
		while (targetElement && targetElement !== document) {
			if (targetElement.matches(selector)) {
				e.preventDefault();
				callback.call(targetElement, e);
				break;
			}
			targetElement = targetElement.parentElement;
		}
	});
}

const splitMenu = () => {
	const menuWrapper = document.querySelector('#navigation .navigation-in')
	if (menuWrapper) {
		setTimeout(() => {
			let menuItems = menuWrapper.querySelectorAll('.menu-level-1>li:not(.appended-category)')
			let menuHelper = document.querySelector('.menu-helper')
			let menuWrapperStyle = window.getComputedStyle(menuWrapper)
			menuItems.forEach((item) => {
				let offsetRight = item.offsetLeft + item.offsetWidth
				const itemInHelper =
					item.id === 'nav-manufacturers'
						? menuHelper.querySelector('#nav-manufacturers')
						: menuHelper.querySelector('.' + item.classList[0])
				if (offsetRight > menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)) {
					if (itemInHelper) {
						itemInHelper.classList.remove('splitted')
					}
					item.classList.add('splitted')
				} else {
					if (itemInHelper) {
						itemInHelper.classList.add('splitted')
					}
					item.classList.remove('splitted')
				}
			})
			if (menuHelper.querySelector('.menu-level-1 > li:not(.splitted):not(.appended-category)')) {
				menuHelper.classList.remove('empty')
				menuWrapper.classList.remove('fitted')
			} else {
				menuHelper.classList.add('empty')
				menuWrapper.classList.add('fitted')
			}
		}, 200)
	}
}

shoptet.menu.splitMenu = splitMenu

// CAROUSEL
const handleCarousel = () => {
	const carousel = document.querySelector('#carousel .carousel-inner')
	if (carousel) {
		let observer = new MutationObserver((mutationList) => {
			let currentItem
			mutationList.forEach((mutation) => {
				if (mutation.target.className === 'item active') {
					currentItem = mutation.target
				}
			})
			if (typeof currentItem == 'undefined') return
			let actualIndex = [...document.querySelectorAll('.carousel-inner .item')].indexOf(currentItem),
				dotsList = document.querySelectorAll('.carousel-dots li')
			dotsList.forEach((dot) => {
				dot.classList.remove('dot-active')
			})
			dotsList[actualIndex].classList.add('dot-active')
		})
		let dotsCounter = 0,
			dotsList = document.createElement('ul')
		dotsList.classList.add('carousel-dots')
		carousel.querySelectorAll('.item').forEach((item, index) => {
			dotsCounter += 1
			let dotEl = document.createElement('li')
			dotsList.appendChild(dotEl)
			if (index === 0) dotEl.classList.add('dot-active')
			dotEl.addEventListener('click', (e) => {
				e.preventDefault()
				document.querySelector('.carousel-inner .item.active').classList.remove('active')
				let targetItem = document.querySelectorAll('.carousel-inner .item')[index]
				const targetItemImg = targetItem.querySelector('img')
				if (!targetItemImg.src) targetItemImg.src = targetItemImg.getAttribute('data-src')
				targetItem.classList.add('active')
			})
			observer.observe(item, {
				attributes: true,
				attributeFilter: ['class'],
			})
		})
		carousel.appendChild(dotsList)
	}
}
handleCarousel()

// FLAGS and card
const handleFlags = (product) => {
	const flagsDefault = product.querySelector('.flags-default')
	const flagsExtra = product.querySelector('.flags-extra')
	const priceStandard = product.querySelector('.price-standard')
	const prices = product.querySelector('.prices')
	const variants = product.querySelector('.widget-parameter-wrapper')
	const img = product.querySelector('.image')
	//

	if (variants && img) {
		img.insertAdjacentElement('afterend', variants)
	}

	if (priceStandard && prices) prices.prepend(priceStandard)
	if (flagsDefault && flagsExtra) {
		flagsDefault.appendChild(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}

	const availability = product.querySelector('.availability')
	const pInIn = product.querySelector('.p-in-in')
	const priceFinal = product.querySelector('.prices')

	if (pInIn && priceFinal) {
		pInIn.appendChild(priceFinal)
	}
	const addToCart = product.querySelector('.add-to-cart-button span')
	if (addToCart) addToCart.innerText = 'Do krabice' //jazyk

	// if (availability && priceFinal) {
	// 	const productHolder = product.querySelector('.holder')
	// 	if (!productHolder) {
	// 		const div = document.createElement('div')
	// 		div.classList.add('holder')
	// 		div.appendChild(availability)
	// 		div.appendChild(priceFinal)
	// 		if (div && pInIn) pInIn.appendChild(div)
	// 	}
	// }
}
// RATINGS
// const handleRatings = (product) => {
// 	if (product.querySelector('.custom-ratings')) return
// 	const ratingsValue = product.querySelector('.stars-wrapper')
// 	const productImage = product.querySelector('.image')
// 	if (ratingsValue) {
// 		const customRatings = document.createElement('div')
// 		customRatings.classList.add('custom-ratings', 'stars')
// 		customRatings.innerHTML = `
// 			${ratingsValue.getAttribute('data-micro-rating-value') || 0} <span class="star star-on"></span> 
// 		`
// 		productImage.appendChild(customRatings)
// 	}
// }
// const handleProductAvailability = (product) => {
// 	const availability = product.querySelector('.availability');
// 	const pBottom = product.querySelector('.p-in .p-in-in');
// 	if (availability && pBottom) pBottom.appendChild(availability);
// }
const mmAllProducts = document.querySelectorAll('.products-block .product')
if (mmAllProducts.length) {
	mmAllProducts.forEach((product) => handleFlags(product))
	// mmAllProducts.forEach((product) => handleRatings(product))
	// mmAllProducts.forEach((product) => handleProductAvailability(product))
}
document.addEventListener('ShoptetDOMContentLoaded', () => {
	const mmAllProducts = document.querySelectorAll('.products-block .product')
	if (mmAllProducts.length) {
		mmAllProducts.forEach((product) => handleFlags(product))
		// mmAllProducts.forEach((product) => handleRatings(product))
		// mmAllProducts.forEach((product) => handleProductAvailability(product))
	}
})


// FOOTER-BOTTOM
function footerBilling() {
	const footerBottom = document.querySelector('.footer-bottom');
	const footerGlobal = document.querySelector('#footer');
	if (footerBottom && footerGlobal) {
		const footerBottomWrapper = document.createElement('div');
		footerBottomWrapper.classList.add('footer-bottom-wrapper');
		footerBottomWrapper.appendChild(footerBottom);
		footerGlobal.parentElement.insertBefore(footerBottomWrapper, footerGlobal.nextElementSibling);
		const signature = footerBottom.querySelector('#signature');
		if (signature) {
			signature.style.display = 'flex';
			const platebniMetodyEl = document.createElement('img');
			platebniMetodyEl.classList.add('platebni-metody');
			platebniMetodyEl.src = '/user/documents/upload/miranda/platebni_metody.png';
			platebniMetodyEl.alt = 'Platební metody';
			signature.parentElement.insertBefore(platebniMetodyEl, signature.nextElementSibling);
		}
	}
}

footerBilling();

// PRODUCT DETAIL
const createShpTabLink = (text, anchor, id) => {
	const shpTabLi = document.createElement('li')
	const shpTabLink = document.createElement('a')
	shpTabLi.classList.add('shp-tab')
	shpTabLi.appendChild(shpTabLink)
	shpTabLink.classList.add('shp-tab-link')
	shpTabLink.href = anchor
	shpTabLink.innerHTML = text
	if (id) {
		shpTabLi.id = id
	}
	return shpTabLi
}

if (document.body.classList.contains('type-detail')) {
	const pDetailTabs = document.querySelector('#p-detail-tabs')
	const tabContent = document.querySelector('#tab-content')

	const customMobileSlider = document.querySelector('.custom-slider-wrapper')
	setTimeout(() => {
		console.log(customMobileSlider)
	}, 3000);

	// if (customMobileSlider) {
	// 	$(customMobileSlider).slick({
	// 		infinite: false,
	// 		arrows: false,
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		dots: true,
	// 	})
	// }
	swiperize({
		containers: '.custom-slider-wrapper',
		slide: '.p-main-image',
		customOptions: {
			fullscreen: false,
			infinity: false,
			dots: false,
			arrows: false,
			scrollbar: false,
			lazyPrevNext: true
		},
		swiperOptions: {
			direction: 'horizontal',
			speed: 800,
			spaceBetween: 20,
			slidesPerView: 1,

		},
	});
	// DLOUHY POPIS + OSTATNI TABY


	const ratingTab = document.querySelector('#ratingTab')
	if (ratingTab) {
		const ratingTabHeading = document.createElement('h3')
		ratingTabHeading.innerHTML = 'Hodnocení'
		ratingTab.prepend(ratingTabHeading)
	}
	const discussionTab = document.querySelector('#productDiscussion')
	if (discussionTab) {
		const discussionHeading = document.createElement('h3')
		discussionHeading.innerHTML = 'Diskuze'
		discussionTab.prepend(discussionHeading)
	}


	const relatedProducts = document.querySelector('.products-related')
	const relatedProductsHeading = document.querySelector('.products-related-header')
	if (relatedProducts && relatedProductsHeading) {
		// relatedProductsHeading.innerText = 'Doporučujeme';
		const titleText = relatedProductsHeading.innerText;




		const relatedProductsCount = relatedProducts.querySelectorAll('.product').length;
		const tabContent = document.querySelector('#tab-content')
		const relatedProductsLink = createShpTabLink(titleText, '#relatedProducts', 'relatedProductsTab');
		// if (pDetailTabs.children[2]) {
		// 	pDetailTabs.insertBefore(relatedProductsLink, pDetailTabs.children[2]);
		// } else {
		pDetailTabs.appendChild(relatedProductsLink);
		// }
		const productContent = document.querySelector('#content')
		relatedProductsHeading.classList.add('homepage-group-title')
		// relatedProductsHeading.innerHTML = `Další produkty z kolekce`
		const relatedProductsTab = document.createElement('div')
		// relatedProductsTab.classList.add('tab-pane')
		relatedProductsTab.id = 'relatedProducts'
		relatedProductsTab.appendChild(relatedProductsHeading)
		relatedProductsTab.appendChild(relatedProducts)
		productContent.appendChild(relatedProductsTab)




		const desc = document.querySelector('.basic-description')
		// desc.parentNode.insertBefore(relatedProductsTab, desc.nextSibling)

		// const shpTabsWrapper = document.querySelector('.shp-tabs-wrapper')
		// const wholeProd = document.querySelector('#relatedProducts')
		// if (shpTabsWrapper && wholeProd) {
		// 	shpTabsWrapper.parentNode.insertBefore(wholeProd, shpTabsWrapper)
		// }
		// productContent.appendChild(relatedProductsTab);

		// Find .products-block inside #relatedProducts and change its class
		// const productsBlock = wholeProd.querySelector('.products-block')
		// if (productsBlock) {
		// 	productsBlock.classList.remove('products-block')
		// 	productsBlock.classList.add('products-inline')

		// }

		// const productBlock = wholeProd.querySelector('.products');
		// const allProducts = wholeProd.querySelectorAll('.products .product');
		// allProducts.forEach((product, index) => {
		// 	const img = product.querySelector('img');
		// 	if (img && img.dataset.src) {
		// 		img.src = img.dataset.src;
		// 	}
		// });
		// if (allProducts.length > 4) {
		// 	const showMoreBtn = document.createElement('a');
		// 	showMoreBtn.className = 'btn btn-border';
		// 	showMoreBtn.textContent = 'Zobrazit další';
		// 	showMoreBtn.style.cursor = 'pointer';

		// 	productBlock.appendChild(showMoreBtn); // Changed to append the button at the end of the productBlock

		// 	showMoreBtn.addEventListener('click', function () {
		// 		const inactiveProducts = wholeProd.querySelectorAll('.products .product.inactive');
		// 		inactiveProducts.forEach(product => {
		// 			product.classList.remove('inactive');
		// 			product.classList.add('active');
		// 		});
		// 		this.style.display = 'none';
		// 	});
		// }
		// $(relatedProducts).slick(productsSlickSettings)


		swiperize({
			containers: '.products-related',
			slide: '.product',
			customOptions: {
				fullscreen: false,
				infinity: false,
				dots: false,
				arrows: true,
				scrollbar: true,
				lazyPrevNext: true
			},
			swiperOptions: {
				direction: 'horizontal',
				speed: 800,
				spaceBetween: 0,
				slidesPerView: 4,
				breakpoints: {
					1440: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
					993: {
						slidesPerView: 3,
						spaceBetween: 0,
					},
					500: {
						slidesPerView: 2,
						spaceBetween: 0,
					},
					0: {
						slidesPerView: 1.25,
						spaceBetween: 16,
						autoplay: false
					}
				},
			},
		});
	}

	const alternativeProductsTabLink = document.querySelector('.shp-tab-link[href="#productsAlternative"]')
	// if (alternativeProductsTabLink) alternativeProductsTabLink.parentElement.remove()
	const alternativeProducts = document.querySelector('#productsAlternative')
	if (alternativeProducts) {
		alternativeProducts.classList.remove('tab-pane', 'fade')
		const alternativeProductsHeading = document.createElement('h2')
		alternativeProductsHeading.classList.add('homepage-group-title')
		const alternativeNadpisy = alternativeNadpis.find((item) => item.language === shoptetLang)
		if (alternativeNadpisy) {
			alternativeProductsHeading.innerHTML = alternativeNadpisy.text
		}
		const productContent = document.querySelector('#content')
		// const helpUSP = document.querySelector('#content > .benefitBanner')
		// if (helpUSP) {
		// 	helpUSP.parentElement.insertBefore(alternativeProductsHeading, helpUSP)
		// 	helpUSP.parentElement.insertBefore(alternativeProducts, helpUSP)
		// } else {

		const holder = document.createElement('div');
		holder.classList.add('holder');
		alternativeProducts.insertBefore(alternativeProductsHeading, alternativeProducts.firstChild);
		productContent.appendChild(alternativeProducts)
		// }
		// $(alternativeProducts.querySelector('.products-block')).slick(productsSlickSettings)

		swiperize({
			containers: '.products-alternative',
			slide: '.product',
			customOptions: {
				fullscreen: false,
				infinity: false,
				dots: false,
				arrows: true,
				scrollbar: true,
				lazyPrevNext: true
			},
			swiperOptions: {
				direction: 'horizontal',
				speed: 800,
				spaceBetween: 0,
				slidesPerView: 4,
				breakpoints: {
					1440: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 0,
					},
					993: {
						slidesPerView: 3,
						spaceBetween: 0,
					},
					500: {
						slidesPerView: 2,
						spaceBetween: 0,
					},
					0: {
						slidesPerView: 1.25,
						spaceBetween: 16,
						autoplay: false
					}
				},
			},
		});
	}



	const parametersTabContent = document.querySelector('#description .extended-description')

	if (parametersTabContent) {
		const parametersTab = createShpTabLink('Specifikace', '#parameters')
		const descriptionTab = document.querySelector('.shp-tab[data-testid="tabDescription"]')
		descriptionTab.after(parametersTab)
		parametersTabContent.id = 'parameters'
	}



	const shpTabLinks = document.querySelectorAll('.shp-tab-link');
	if (shpTabLinks.length) {
		shpTabLinks.forEach((link) => {
			link.removeAttribute('role');
			link.removeAttribute('data-toggle');

			// Odstranění závorek a čísel z textu odkazu
			link.textContent = link.textContent.replace(/\(\d+\)/g, '').trim();
		});
	}
	const targetNode = document.querySelector('.shp-tabs-row');

	if (targetNode) {
		const config = { childList: true, subtree: true };

		const callback = function (mutationsList, observer) {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const hiddenLinks = document.querySelector('.shp-tabs-row .hidden-links');
					const shpTabsRow = document.querySelector('.shp-tabs-row .shp-tabs');

					if (hiddenLinks && shpTabsRow) {
						// Přesunout všechny .shp-tab do .shp-tabs-row .shp-tabs
						const shpTabs = hiddenLinks.querySelectorAll('.shp-tab');
						shpTabs.forEach(tab => {
							shpTabsRow.appendChild(tab);
						});

						// Odstranit .hidden-links
						hiddenLinks.remove();
					}
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetNode, config);

		// Přidat posluchače událostí pro resize a orientationchange
		window.addEventListener('resize', () => observer.observe(targetNode, config));
		window.addEventListener('orientationchange', () => observer.observe(targetNode, config));
	}


}

// CART
const handleCart = () => {
	const pageHeader = document.querySelector('#header')
	const cartHeader = document.querySelector('.cart-content .cart-header')
	const cartHeaderHelper = document.querySelector('.cart-header-wrapper')
	const search = document.querySelector('.search')
	const headerTop = document.querySelector('.header-top')

	const changeTitle = document.querySelector('.co-delivery-method h4')
	if (changeTitle) {
		changeTitle.innerText = 'Zvolte způsob převzetí' //jazyk
	}
	console.log(search)
	console.log(headerTop)
	if (search && headerTop) {
		headerTop.appendChild(search)
	}
	if (cartHeader && !cartHeaderHelper) {
		const cartHeaderWrapper = document.createElement('div')
		cartHeaderWrapper.classList.add('cart-header-wrapper')
		cartHeaderWrapper.appendChild(cartHeader)
		cartHeader.classList.add('container')
		pageHeader.parentElement.insertBefore(cartHeaderWrapper, pageHeader.nextElementSibling)
	} else if (cartHeader) {
		cartHeader.remove()
	}

	// const discountForm = document.querySelector('.discount-coupon')
	// const summaryWrapper = document.querySelector('.summary-wrapper')
	// if (discountForm && summaryWrapper) {
	// 	summaryWrapper.prepend(discountForm)
	// 	const discountInput = discountForm.querySelector('input')
	// 	discountInput.placeholder = 'Vložte kód'
	// }
	const sidebarCart = document.querySelector('.sidebar-in-cart')
	// const sidebarCart = document.querySelector('.sidebar-in-cart .box[data-testid="tableCart"]')
	const extraDelivery = document.querySelector('.extra.delivery')
	if (extraDelivery && sidebarCart) {
		if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0) extraDelivery.classList.add('free-shipping')
		sidebarCart.appendChild(extraDelivery)
		// sidebarCart.prepend(extraDelivery)
	}

	const overallWrapper = document.querySelector('.overall-wrapper')
	const cartFooter = document.createElement('div')
	cartFooter.classList.add('cart-footer')
	if (overallWrapper) overallWrapper.appendChild(cartFooter)
	const cartMail = document.querySelector('.contact-box .mail')
	const cartPhone = document.querySelector('.contact-box .tel')

	const sidebarNextStep = document.querySelector('#checkoutSidebar .next-step')
	const orderSummary = document.querySelector('#summary-box')
	if (sidebarNextStep && orderSummary) orderSummary.appendChild(sidebarNextStep)

	// const nextStep = document.querySelector(".next-step-back");
	// if(nextStep) {

	// }

	const sidebarConsents = document.querySelectorAll('#checkoutSidebar .consents')
	const summaryItemPrice = document.querySelector('#checkoutSidebar .order-summary-item.price')
	if (sidebarConsents.length && summaryItemPrice) {
		sidebarConsents.forEach((consent) => {
			summaryItemPrice.parentElement.insertBefore(consent, summaryItemPrice.nextElementSibling)
		})
	}
	if (window.innerWidth <= 1300) {
		const backHolder = document.querySelector('.cart-inner');
		const backHold = document.querySelector(".back-shopping-link");
		if (backHolder && backHold) {
			backHolder.appendChild(backHold);
		}
	}
	// const backToShopButtons = document.querySelectorAll('.back-to-shop')
	// if (backToShopButtons.length) {
	// 	backToShopButtons.forEach((button) => {
	// 		button.innerText = 'ZPĚT K NÁKUPNÍMU KOŠÍKU'
	// 	})
	// }

	// const backToShop = document.querySelector('.back-to-shop')
	// if (backToShop) {
	// 	// console.log(backToShop)
	// 	const backToShopLinks = document.querySelector('.back-shopping-link')
	// 	if (backToShopLinks) {
	// 		// console.log(backToShopLinks)
	// 		backToShopLinks.appendChild(backToShop);
	// 	}
	// }
	const paymentInfoTooltips = document.querySelectorAll('.payment-info .show-tooltip')
	if (paymentInfoTooltips.length) {
		paymentInfoTooltips.forEach((tooltip) => {
			tooltip.innerText = 'i'
		})
	}
	const handleFreeRecapitulation = () => {
		setTimeout(() => {
			const recapItemPrices = document.querySelectorAll('.recapitulation-shipping-billing-info > span')
			if (recapItemPrices.length) {
				recapItemPrices.forEach((price) => {
					if (price.innerText.toUpperCase().includes('ZDARMA')) {
						price.classList.add('for-free')
					} else {
						price.classList.remove('for-free')
					}
				})
			}
		}, 100)
	}
	document.addEventListener('ShoptetShippingMethodUpdated', handleFreeRecapitulation)
	document.addEventListener('ShoptetBillingMethodUpdated', handleFreeRecapitulation)

	const recapItemPrices = document.querySelectorAll('span[data-testid="recapItemPrice"]')
	if (recapItemPrices.length) {
		recapItemPrices.forEach((price) => {
			if (price.innerText.toUpperCase().includes('ZDARMA')) {
				price.classList.add('for-free')
			} else {
				price.classList.remove('for-free')
			}
		})
	}

	const continueOrderButton = document.querySelector('#continue-order-button')
	if (continueOrderButton) {
		continueOrderButton.innerText = 'Pokračovat v objednávce' //jazyk
	}

	// const relatedProductsBuyButton = document.querySelectorAll('.cart-related-product .add-to-cart-button')
	// if (relatedProductsBuyButton.length) {
	// 	relatedProductsBuyButton.forEach((button) => {
	// 		button.innerText = 'Koupit' //jazyk
	// 	})
	// }

	const footerCheck = document.querySelector('.ordering-process-footer')
	if (!footerCheck) {
		const cartProjectMail = document.querySelector('.contact-box .mail')
		const cartProjectPhone = document.querySelector('.contact-box .tel')
		const orderingProcessFooter = document.createElement('footer')
		orderingProcessFooter.classList.add('ordering-process-footer')
		orderingProcessFooter.innerHTML = `
			<div class="container">
				<div class="secure-payment">
					<span>Bezpečná platba</span>
					<img src="/user/documents/upload/miranda/platebni_metody-2.png" width="286" height="23" alt="Visa, MasterCard, Maestro, PayPal"/>
				</div>
				<div class="contact-box phone-wrapper">
				<span>Po - Pa 10:00 - 16:00</span>
				</div>
				<div class="contact-box mail-wrapper">
					
				</div>
			</div>
		` //jazyk
		overallWrapper.appendChild(orderingProcessFooter)
		const orderingProcessFooterPhoneWrapper = orderingProcessFooter.querySelector('.phone-wrapper')
		const orderingProcessFooterMailWrapper = orderingProcessFooter.querySelector('.mail-wrapper')
		if (cartProjectPhone) {
			const clonedPhone = cartProjectPhone.cloneNode(true);
			orderingProcessFooterPhoneWrapper.prepend(clonedPhone);
			const phoneElement = orderingProcessFooter.querySelector('.phone-wrapper .tel');
			if (phoneElement) {
				phoneElement.classList.add('project-phone');
				phoneElement.classList.remove('tel'); // Odstranění třídy 'tel'
			}
		}

		if (cartProjectMail) {
			const clonedMail = cartProjectMail.cloneNode(true);
			orderingProcessFooterMailWrapper.prepend(clonedMail);
			const mailElement = orderingProcessFooter.querySelector('.mail-wrapper .mail a');
			if (mailElement) {
				mailElement.classList.add('project-email');
				mailElement.classList.remove('mail'); // Odstranění třídy 'mail'
			}
		}
	}
	if (shoptetPage === 'cart') {
		const productsInCart = document.querySelectorAll('.cart-table tr.removeable[data-micro="cartItem"]')
		productsInCart.forEach((product) => {
			const productSKU = product.getAttribute('data-micro-sku')
			const productName = product.querySelector('.p-name')
			if (productSKU && productName) {
				const productSKUEl = document.createElement('div')
				productSKUEl.classList.add('product-sku')
				productSKUEl.innerHTML = `Kód: ${productSKU}`
				productName.appendChild(productSKUEl)
			}
		})
	}

	const products = document.querySelectorAll('tbody [data-micro="cartItem"]')
	if (products.length) {
		products.forEach((product) => {
			const pQuantity = product.querySelector('.p-availability ')
			const pName = product.querySelector('.p-name')
			const mainLink = pName.querySelector('.main-link')

			if (pQuantity && pName && mainLink) {
				const quantityHtml = pQuantity.innerHTML
				mainLink.insertAdjacentHTML('afterend', `<div class="availability">${quantityHtml}</div>`)
			}
		})
	}



	const cartSummary = document.querySelector('.summary-wrapper')
	if (cartSummary) {
		const box = cartSummary.querySelector('.box')
		const upperSummaryReayl = document.querySelector('.upper-summary')
		if (box) {
			const upperSummary = document.createElement('div')
			upperSummary.classList.add('upper-summary')
			box.prepend(upperSummary)

			const cartContentSummary = document.querySelector('.cart-content .cart-summary')
			if (cartContentSummary) {
				const cartInner = document.querySelector('.cart-inner')
				box.appendChild(cartContentSummary)

				const h4 = cartContentSummary.querySelector('h4')
				if (h4) {
					h4.innerHTML = extraGiftTitles.find((item) => item.language === shoptetLang)?.text
					if (!cartContentSummary.querySelector('.discount-coupon')) {
						h4.style.display = 'none'
					}

					// h4.addEventListener('click', function () {
					// 	this.classList.toggle('active')
					// 	const discountCoupon = cartContentSummary.querySelector('.discount-coupon')
					// 	if (discountCoupon) {
					// 		discountCoupon.classList.toggle('active')
					// 	}
					// })
				}
				if (cartContentSummary.querySelector('.discount-coupon .applied-coupon')) {
					const discountCoupon = cartContentSummary.querySelector('.discount-coupon')
					h4.classList.add('active')
					discountCoupon.classList.add('active')
				}

				const button = cartContentSummary.querySelector('.discount-coupon button')
				if (button) {
					button.innerHTML = 'Uplatnit' //jazyk
				}
				const freeGift = cartContentSummary.querySelector('.free-gift')
				if (freeGift) {
					const h4Gift = document.createElement('h4')
					h4Gift.innerHTML = 'Dárek'
					box.insertBefore(freeGift, upperSummary)
					freeGift.prepend(h4Gift)
				}
			}

			const priceHolder = document.createElement('div')
			priceHolder.classList.add('price-holder')
			upperSummary.appendChild(priceHolder)

			// if (totalSaved > 0) {
			// 	const saveHolder = document.createElement('span');
			// 	saveHolder.classList.add('save-holder');
			// 	const totalSavedActualCurrency = totalSaved.ShoptetFormatAsCurrency();
			// 	saveHolder.innerHTML = `Ušetříte: ${totalSavedActualCurrency}`;
			// 	priceHolder.appendChild(saveHolder);
			// }

			const priceWrapper = cartSummary.querySelector('.price-wrapper')
			if (priceWrapper) {
				priceHolder.appendChild(priceWrapper)
			}

			const shipping = document.querySelector('.extra.delivery')
			if (shipping) {
				// upperSummary.insertAdjacentElement('afterend', shipping)
				cartSummary.prepend(shipping)
			}
		}
	}
	const nextStepH = document.querySelector(".next-step");
	if (nextStepH) {
		const upperSummary = document.querySelector('.upper-summary');
		if (upperSummary) {
			upperSummary.appendChild(nextStepH);
		}
	}

	if (document.querySelector('body').classList.contains('id--9')) {
		const cartH2 = document.createElement('h2')
		const h2 = document.querySelector('.cart-row .col-md-8 h2')
		if (cartH2 && !h2) {
			cartH2.innerHTML = itemsCartTitle.find((item) => item.language === shoptetLang)?.text
			const row = document.querySelector('.cart-row .col-md-8 .cart-content')
			if (row) {
				row.insertBefore(cartH2, row.firstChild)
			}
		}
	}
	window.shippingDateChange = [
		{ language: "cs", text: "Možné doručit od:" },
		{ language: "sk", text: "Možné doručit od:" }
	]

	const deliveryTime = document.querySelector('.delivery-time');
	if (deliveryTime) {
		const fromDate = shippingDateChange.find((item) => item.language === shoptetLang)?.text;
		const strong = deliveryTime.querySelector('strong');
		if (fromDate && strong) {
			deliveryTime.innerHTML = `${fromDate} ${strong.outerHTML}`;
		}
	}
}
if (document.body.classList.contains('ordering-process')) {
	handleCart()
	document.addEventListener('ShoptetDOMCartContentLoaded', handleCart)

	// const allCartProducts = document.querySelectorAll('.cart-table tbody tr[data-micro="cartItem"], .free-gift .free-gifts-wrapper')
	// if (allCartProducts.length > 0) {
	// 	let cartProductsData = []
	// 	allCartProducts.forEach((product) => {
	// 		let productData = {
	// 			sku: product.getAttribute('data-micro-sku') || product.querySelector('.free-gift-name')?.innerHTML,
	// 			imageHTML: product.querySelector('.cart-p-image, .free-gifts-img')?.innerHTML,
	// 		}
	// 		cartProductsData.push(productData)
	// 	})
	// 	sessionStorage.setItem('cartProductsData', JSON.stringify(cartProductsData))
	// }

	// const cartItems = document.querySelectorAll('.cart-items .cart-item, .gift-items span[data-testid="recapItemName"]')
	// if (cartItems.length > 0) {
	// 	let cartProductsData = JSON.parse(sessionStorage.getItem('cartProductsData'))
	// 	if (!cartProductsData || cartItems.length > cartProductsData.length) {
	// 		fetch('/kosik/')
	// 			.then((response) => response.text())
	// 			.then((data) => {
	// 				const parser = new DOMParser()
	// 				const doc = parser.parseFromString(data, 'text/html')
	// 				const allCartProducts = doc.querySelectorAll(
	// 					'.cart-table tbody tr[data-micro="cartItem"], .free-gift .free-gifts-wrapper'
	// 				)
	// 				cartProductsData = []
	// 				allCartProducts.forEach((product) => {
	// 					let productData = {
	// 						sku: product.getAttribute('data-micro-sku') || product.querySelector('.free-gift-name')?.innerHTML,
	// 						imageHTML: product.querySelector('.cart-p-image, .free-gifts-img')?.innerHTML,
	// 					}
	// 					cartProductsData.push(productData)
	// 				})
	// 				sessionStorage.setItem('cartProductsData', JSON.stringify(cartProductsData))
	// 				updateCartItems(cartItems, cartProductsData)
	// 			})
	// 	} else {
	// 		updateCartItems(cartItems, cartProductsData)
	// 	}
	// }

	// function updateCartItems(cartItems, cartProductsData) {
	// 	cartItems.forEach((item) => {
	// 		const itemSku = item.getAttribute('data-micro-sku') || item.innerHTML
	// 		const matchingProductData = cartProductsData.find((productData) => productData.sku === itemSku)
	// 		if (matchingProductData) {
	// 			item.innerHTML = matchingProductData.imageHTML + item.innerHTML
	// 		}
	// 	})
	// }

	// const observer = new MutationObserver((mutationsList, observer) => {
	// 	for (let mutation of mutationsList) {
	// 		if (mutation.type === 'childList') {
	// 			const images = document.querySelectorAll('.cart-item a img')
	// 			images.forEach((img) => {
	// 				if (img.getAttribute('data-src')) {
	// 					img.src = img.getAttribute('data-src')
	// 				}
	// 			})
	// 			const links = document.querySelectorAll('.cart-item a')
	// 			links.forEach((link) => {
	// 				if (link.querySelector('img')) {
	// 					link.classList.add('product-icon')
	// 				}
	// 			})
	// 		}
	// 	}
	// })

	// observer.observe(document.body, { childList: true, subtree: true })
}

// POPUP CART
document.addEventListener('ShoptetDOMCartContentLoaded', () => {
	const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol
	const cartWidgetProducts = document.querySelectorAll('.cart-widget-product')
	if (cartWidgetProducts.length) {
		cartWidgetProducts.forEach((product) => {
			const productPrice = product.querySelector('span[data-testid="cartWidgetProductPrice"]')
			if (productPrice) {
				const priceEl = document.createElement('div')
				priceEl.classList.add('cart-widget-product-price')
				priceEl.appendChild(productPrice)
				product.appendChild(priceEl)
				const productSKU = product.getAttribute('data-micro-sku')
				if (productSKU) {
					const productSinglePrice = dataLayer[0].shoptet.cart.filter((item) => item.code === productSKU)[0].priceWithVat
					const productSinglePriceEl = document.createElement('div')
					productSinglePriceEl.classList.add('cart-widget-product-single-price')
					productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks` //jazyk
					priceEl.appendChild(productSinglePriceEl)
				}
			}
		})
	}

	let popupCartSummary = document.querySelector('.popup-cart-summary')
	if (!popupCartSummary) {
		popupCartSummary = document.createElement('div')
		popupCartSummary.classList.add('popup-cart-summary')
	}
	let popupCartSummaryPriveVAT = String(dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat)
	if (popupCartSummaryPriveVAT.includes('.')) {
		popupCartSummaryPriveVAT = popupCartSummaryPriveVAT.replace('.', ',')
	}

	let popupCartSummaryPriceNoVAT = String(dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat)
	if (popupCartSummaryPriceNoVAT.includes('.')) {
		popupCartSummaryPriceNoVAT = popupCartSummaryPriceNoVAT.replace('.', ',')
	}
	console.log(popupCartSummaryPriceNoVAT)

	// Převod řetězce na číslo
	let popupCartSummaryPriceNoVATNumber = parseFloat(popupCartSummaryPriceNoVAT.replace(',', '.'))

	popupCartSummary.innerHTML = `
    <div class="popup-cart-summary-item">
        <strong class="popup-cart-summary-item-label">Celkem za zboží</strong>
        <strong class="popup-cart-summary-item-value">${popupCartSummaryPriveVAT} ${currencyLabel}</strong>
    </div>
    <div class="popup-cart-summary-item">
        <span class="popup-cart-summary-item-label">Celkem bez DPH</span>
        <span class="popup-cart-summary-item-value">${Math.round(popupCartSummaryPriceNoVATNumber)} ${currencyLabel}</span>
    </div>
` //jazyk
	const cartWidgetProductsWrapper = document.querySelector('.cart-widget-products')
	if (cartWidgetProductsWrapper)
		cartWidgetProductsWrapper.parentElement.insertBefore(popupCartSummary, cartWidgetProductsWrapper.nextElementSibling)

	const cartWidgetButton = document.querySelector('.cart-widget-button')
	const cartWidgetInner = document.querySelector('.cart-widget-inner')
	if (cartWidgetButton && cartWidgetInner) cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true))

	const cartWidgetShipping = document.querySelector('.cart-free-shipping')
	if (cartWidgetShipping) {
		const priceLeftToFreeShipping = dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft
		if (priceLeftToFreeShipping > 0) {
			const freeShippingBar = document.createElement('div')
			const freeShippingValue = document.createElement('div')
			freeShippingBar.classList.add('price-range')
			freeShippingBar.appendChild(freeShippingValue)
			freeShippingValue.style.width = `${100 - (100 * priceLeftToFreeShipping) / (priceLeftToFreeShipping + popupCartSummaryPriveVAT)
				}%`
			cartWidgetShipping.appendChild(freeShippingBar)
			const shippingWidgetStrongs = cartWidgetShipping.querySelectorAll('strong')
			if (shippingWidgetStrongs.length) {
				shippingWidgetStrongs.forEach((strong) => {
					if (strong.innerText.includes('ZDARMA')) strong.classList.add('free-shipping-strong') //jazyk
				})
			}
		}
	}
})
// document.addEventListener('ShoptetCartUpdated', () => {
// 	const popupCartSummary = document.querySelector('.popup-cart-summary')
// 	console.log(popupCartSummary)
// 	// const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
// 	// const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
// 	// const popupCartPriceVAT = popupCartSummary.querySelector('strong.popup-cart-summary-item-value')
// 	// const popupCartPriceNoVAT = popupCartSummary.querySelector('span.popup-cart-summary-item-value')
// 	// popupCartPriceVAT.innerHTML = `${popupCartSummaryPriveVAT} ${currencyLabel}`
// 	// popupCartPriceNoVAT.innerHTML = `${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}`
// })

// ADVANCED ORDER
document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
	const advancedOrder = document.querySelector('.advanced-order')
	const aoTop = document.createElement('div')
	aoTop.classList.add('ao-top')
	advancedOrder.prepend(aoTop)
	const aoTitle = advancedOrder.querySelector('.h1')
	if (aoTitle) aoTop.appendChild(aoTitle)
	const aoProduct = advancedOrder.querySelector('.ao-product') || advancedOrder.querySelector('.h2')
	if (aoProduct) aoTop.appendChild(aoProduct)
	const cboxClose = document.querySelector('#cboxClose')
	if (cboxClose) {
		cboxClose.innerText = 'Zavřít' //jazyk
		cboxClose.id = 'cboxClose'
		cboxClose.classList.add('close')
		// aoTop.appendChild(cboxClose)
	}
	const continueShoppingBtn = document.createElement('button')
	continueShoppingBtn.classList.add('btn', 'black-border')
	continueShoppingBtn.innerText = 'Zavřít' //jazyk
	continueShoppingBtn.addEventListener('click', () => {
		shoptet.modal.close()
	})
	const extraStep = advancedOrder.querySelector('.extra.step')
	if (extraStep) extraStep.prepend(continueShoppingBtn)

	const deliveryStrongs = advancedOrder.querySelectorAll('.extra.delivery strong')
	if (deliveryStrongs.length) {
		deliveryStrongs.forEach((strong) => {
			if (strong.innerText === 'ZDARMA') strong.classList.add('for-free') //jazyk
		})
	}
	const suggestion = advancedOrder.querySelector('.advanced-order-suggestion')
	if (suggestion) {
		suggestion.innerHTML = 'Můžete ještě přidat ...'
	}
	const img = advancedOrder.querySelector('.ao-product .ao-image img')
	if (img) {
		img.src = img.getAttribute('data-src')
	}

	const advancedOrderProducts = $('.colorbox-html-content #products')
	if (advancedOrderProducts.length) {
		advancedOrderProducts.slick(productsSlickSettings)
	}
})

// EMPTY CART
window.prazdnyKosikNadpis = [
	{ language: "cs", text: "Váš košík je prázdný." },
	{ language: "en", text: "Your cart is empty." }
];

window.prazdnyKosikPerex = [
	{ language: "cs", text: "Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte přímo nám, rádi vám pomůžeme." },
	{ language: "en", text: "If you don't know which product to choose, try looking at our guide or call us directly, we are happy to help." }
];

window.primaryButtonText = [
	{ language: "cs", text: "Zpět do obchodu", url: "/" },
	{ language: "en", text: "Back to shop", url: "/" }
];

window.secondaryButtonText = [
	{ language: "cs", text: "Kontakty", url: "/kontakty" },
	{ language: "en", text: "Contacts", url: "/contacts" }
];

window.emailPerexText = [
	{ language: "cs", text: "Odpovídáme do 24 hodin" },
	{ language: "en", text: "We respond within 24 hours" }
];
const handleEmptyCart = () => {
	const emptyCart = document.querySelector('.cart-inner.cart-empty');
	document.body.classList.add('custom-empty-cart');
	const cartHeading = emptyCart.querySelector('.cart-heading');
	const cartText = document.createElement('p');
	cartText.classList.add('narrow-custom', 'text-center');
	const prazdnyKosikPerexText = window.prazdnyKosikPerex.find((item) => item.language === shoptetLang).text;
	cartText.innerText = prazdnyKosikPerexText;
	if (cartHeading) {
		const prazdnyKosikNadpisText = window.prazdnyKosikNadpis.find((item) => item.language === shoptetLang).text;
		cartHeading.innerText = prazdnyKosikNadpisText;
		cartHeading.classList.add('homepage-group-title');
		cartHeading.parentElement.insertBefore(cartText, cartHeading.nextElementSibling);
	}
	const cartEmail = emptyCart.querySelector('.mail');
	const cartPhone = emptyCart.querySelector('.tel');
	const cartContact = document.createElement('ul');
	cartContact.classList.add('cart-contact', 'contact-box');
	if (cartPhone) {
		cartContact.appendChild(cartPhone.parentElement);
	}
	if (cartEmail) {
		// const emailPerexText = window.emailPerexText.find((item) => item.language === shoptetLang).text;
		const emailPerex = document.createElement('span');
		// emailPerex.innerText = emailPerexText;
		cartEmail.parentElement.insertBefore(emailPerex, cartEmail.nextElementSibling);
		cartContact.appendChild(cartEmail.parentElement);
	}
	emptyCart.appendChild(cartContact);

	// Přidání btn holder s dvěma odkazy
	const btnHolder = document.createElement('div');
	btnHolder.classList.add('btn-holder', 'text-center');

	const primaryButton = window.primaryButtonText.find((item) => item.language === shoptetLang);
	const secondaryButton = window.secondaryButtonText.find((item) => item.language === shoptetLang);

	btnHolder.innerHTML = `
        <a href="${primaryButton.url}" class="btn btn-primary">${primaryButton.text}</a>
        <a href="${secondaryButton.url}" class="btn secondary">${secondaryButton.text}</a>
    `;

	emptyCart.appendChild(btnHolder);

	const emptyCartHeader = document.querySelector('.cart-header-wrapper');
	if (emptyCartHeader) emptyCartHeader.remove();
};

const emptyCart = document.querySelector('.cart-inner.cart-empty');
if (emptyCart) handleEmptyCart();

document.addEventListener('ShoptetDOMCartContentLoaded', () => {
	if (!dataLayer[0].shoptet.cart.length) handleEmptyCart();
});

// EMPTY CART POPUP
// const handleEmptyCartPopup = () => {
// 	const isEmpty = document.querySelector('.cart-widget .place-cart-here')
// 	if (isEmpty) {
// 		const toggleCart = document.querySelector('.toggle-window.cart-count')
// 		if (toggleCart) {
// 			toggleCart.addEventListener('mouseenter', () => document.body.classList.add('user-action-visible', 'cart-window-visible'))
// 			// toggleCart.addEventListener('mouseleave', () => document.body.classList.remove('user-action-visible', 'cart-window-visible'))
// 		}
// 		const cartLoader = isEmpty.querySelector('.loader-overlay')
// 		if (cartLoader) cartLoader.remove()
// 		const emptyCartPopup = document.createElement('div')
// 		emptyCartPopup.classList.add('empty-cart-popup')

// 		emptyCartPopup.innerHTML = `
// 			<h2>Ve vašem košíku nemáte žádné zboží</h2>
// 			<p>Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte Majyi, která Vám s výběrem velmi ráda pomůže.</p>
// 			<div class="contact-box phone-placeholder">
// 			</div>
// 			<div class="contact-box mail-placeholder">
// 				<span>Odpovídáme do 24 hodin</span>
// 			</div>
// 			<p>Nebo přejděte na naše kategorie</p>
// 			<ul class="subcategories">
// 			</ul>
// 		` //jazyk
// 		if (typeof emptyCartSubcategories !== 'undefined') {
// 			const subcategoriesWrapper = emptyCartPopup.querySelector('.subcategories')
// 			emptyCartSubcategories.forEach((subcategory) => {
// 				const subcategoryEl = document.createElement('li')
// 				subcategoryEl.innerHTML = `
// 					<a href="${subcategory.link}">
// 						<span class="text">${subcategory.text}</span>
// 						<span class="image">
// 							<img src="${subcategory.image}" alt="" />
// 						</span>
// 					</a>
// 				`
// 				subcategoriesWrapper.appendChild(subcategoryEl)
// 			})
// 		}
// 		isEmpty.appendChild(emptyCartPopup)
// 		const projectMail = document.querySelector('.contact-box .mail')
// 		const projectPhone = document.querySelector('.contact-box .tel')
// 		const phonePlaceholder = emptyCartPopup.querySelector('.phone-placeholder')
// 		const mailPlaceholder = emptyCartPopup.querySelector('.mail-placeholder')
// 		if (projectPhone) {
// 			phonePlaceholder.appendChild(projectPhone.cloneNode(true))
// 			// if (headerOpeningHours) {
// 			// 	const phonePerex = document.createElement('span')
// 			// 	phonePerex.innerText = headerOpeningHours
// 			// 	phonePlaceholder.appendChild(phonePerex)
// 			// }
// 		}
// 		if (projectMail) {
// 			mailPlaceholder.prepend(projectMail.cloneNode(true))
// 		}
// 	}
// }
// handleEmptyCartPopup()
window.addEventListener('beforeunload', function (event) {
	window.sessionStorage.removeItem('openedFilters')
})

// const backToTop = document.querySelector('#back-to-top')
// if (backToTop) {
// 	backToTop.addEventListener('click', (e) => {
// 		e.preventDefault()
// 		window.scrollTo(0, 0)
// 	})
// }

const handleFooter = async () => {
	// const socialIcons = document.querySelector('.footer-links-icons')
	// const contactBanner = document.querySelector('.custom-footer__contact')
	// if (socialIcons && contactBanner) contactBanner.appendChild(socialIcons)

	const signature = document.querySelector('#signature')
	if (signature) {
		const mirandaMediaLink = `
			<a class="company" href="https://www.mirandamedia.cz/shoptetnamiru" target="_blank">
				<img class="company__logo" src="/user/documents/miranda.svg">
				MirandaMedia Group s.r.o
			</a>
		`
		signature.insertAdjacentHTML('beforeend', mirandaMediaLink)
	}
	const footerHeadings = document.querySelectorAll('.banner-wrapper > span > h4')
	footerHeadings.forEach((heading) => {
		heading.classList.add('clickable')
		heading.addEventListener('click', () => {
			heading.closest('.banner-wrapper').classList.toggle('active')
		})
	})
	const footerCategories = document.querySelector('.custom-footer__categories > h4')
	if (footerCategories) {
		footerCategories.classList.add('clickable')
		footerCategories.addEventListener('click', () => {
			footerCategories.closest('.custom-footer__categories').classList.toggle('active')
		})
	}
	const instagram = document.querySelector('.custom-footer__instagram');
	const footer = document.querySelector('#footer');
	if (instagram && footer) {
		const h4 = instagram.querySelector('h4');
		h4.classList.add('homepage-group-title');
		h4.innerHTML = "@erhartovacukrarna"
		const instagramWrapper = instagram.querySelector('.instagram-widget');
		footer.before(instagram);
		const allPosts = instagramWrapper.querySelectorAll('a');
		allPosts.forEach((post) => {
			const div = document.createElement('div');
			const span = document.createElement('span');
			const img = document.createElement('img');
			span.textContent = "Sledujte nás na";
			img.src = "/user/documents/upload/miranda/instagram-text.svg";
			div.appendChild(span);
			div.appendChild(img);
			post.appendChild(div);
		});
		// $('.custom-footer__instagram .instagram-widget').slick({
		// 	arrows: true, // No arrows
		// 	dots: false, // No dots
		// 	infinite: true,
		// 	slidesToShow: 6,
		// 	slidesToScroll: 1,
		// 	responsive: [
		// 		{
		// 			breakpoint: 1350,
		// 			settings: {
		// 				slidesToShow: 5,
		// 				infinite: true,
		// 			},
		// 		},
		// 		{
		// 			breakpoint: 1100,
		// 			settings: {
		// 				slidesToShow: 4,
		// 				infinite: false,
		// 			},
		// 		},
		// 		{
		// 			breakpoint: 768,
		// 			settings: {
		// 				slidesToShow: 3,
		// 				infinite: false,
		// 			},
		// 		},

		// 	],
		// });
	}
	const siteName = document.querySelector('#footer .site-name');
	const customFooter = document.querySelector('#footer .custom-footer');
	if (customFooter) {
		customFooter.insertBefore(siteName, customFooter.firstChild);
	}
	const customFooterContact = document.querySelector('#footer .custom-footer__contact')
	const customFooterContactPlaceholder = document.querySelector('#footer .contacts-placeholder')
	if (customFooterContact && customFooterContactPlaceholder) {
		customFooterContactPlaceholder.append(customFooterContact)
	}

	const footeSiteNameImg = document.querySelector('#footer .site-name img')
	if (footeSiteNameImg) {
		footeSiteNameImg.src = '/user/documents/upload/miranda/logo-footer.svg'
	}
	const socialBanner = document.querySelector('.social-wrapper')
	if (socialBanner) {
		siteName.appendChild(socialBanner)
	}
}
handleFooter()


// const shoptetPage = dataLayer[0].shoptet.pageType
// const shoptetLang = dataLayer[0].shoptet.language

// const handleUSP = () => {
// 	const benefitBanner = document.querySelector('.benefitBanner')
// 	if (benefitBanner) {
// 		if (dataLayer[0].shoptet.pageType === 'homepage') {
// 			const firstProductsBlock = document.querySelectorAll('.products-block')
// 			if (firstProductsBlock.length)
// 				firstProductsBlock[0].parentElement.insertBefore(benefitBanner, firstProductsBlock[0].nextElementSibling)
// 		}
// 	}
// }
// handleUSP()

// const handleHomepageProducts = async () => {
// 	const productBlocks = document.querySelectorAll('.products-block');
// 	if (productBlocks.length > 0) {
// 		$(productBlocks[0]).slick(productsSlickSettings);
// 	}

// }
if (shoptetPage === 'homepage') {


	const productsSelectors = () => {
		const allProducts = document.querySelectorAll('.products');

		if (!allProducts) return;

		const productsIDs = [];

		for (const products of allProducts) {
			// if (index === 0) continue;

			productsIDs.push(`#${products.id}`);
		}
		console.log(productsIDs)
		return productsIDs;
	}

	swiperize({
		containers: [
			...productsSelectors(),
		],
		slide: [
			swiperize.spreadClass(productsSelectors(), '.product'),
		],
		customOptions: {
			fullscreen: false,
			infinity: false,
			dots: false,
			arrows: true,
			scrollbar: true,
			lazyPrevNext: true
		},
		swiperOptions: {
			direction: 'horizontal',
			speed: 800,
			spaceBetween: 0,
			slidesPerView: 1.25,
			breakpoints: {
				1440: {
					slidesPerView: 4,
					spaceBetween: 0,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 0,
				},
				993: {
					slidesPerView: 3,
					spaceBetween: 0,
				},
				500: {
					slidesPerView: 2,
					spaceBetween: 0,
				},

			},
		},
	});


	function homePageSections() {
		let headingElements = document.querySelectorAll('.homepage-group-title');
		let insertAfterElement = document.querySelector('.before-carousel');

		if (document.querySelector("body").classList.contains("mobile")) {
			insertAfterElement = document.querySelector('.banners-row');
		}

		headingElements.forEach((heading, index) => {
			let splitClass = heading.className.split('homepage-products-heading-');
			if (splitClass.length > 1) {
				let headingNumber = splitClass[1].split(' ')[0];
				let productElement = document.querySelector(`.homepage-products-${headingNumber}`);

				if (productElement) {
					const section = document.createElement('section');
					section.classList.add('product-section', `product-section-${headingNumber}`);
					const container = document.createElement('div');
					container.classList.add('container');

					section.appendChild(container);
					container.appendChild(heading);
					container.appendChild(productElement);

					if (insertAfterElement) {
						insertAfterElement.insertAdjacentElement('afterend', section);
						insertAfterElement = section; // Aktualizujeme insertAfterElement na nově vloženou sekci
					}
				}
			}
		});
	}

	// Volání funkce
	homePageSections();

	if (window.innerWidth < 1120) {
		swiperize({
			containers: '.services-swiper',
			slide: '.block',
			customOptions: {
				fullscreen: false,
				infinity: false,
				dots: false,
				arrows: true,
				scrollbar: true,
				lazyPrevNext: true
			},
			swiperOptions: {
				direction: 'horizontal',
				speed: 800,
				spaceBetween: 16,
				slidesPerView: 2,
				breakpoints: {

					768: {
						slidesPerView: 5,
						spaceBetween: 16,
					},
					480: {
						slidesPerView: 3,
						spaceBetween: 16,
						autoplay: false
					}
				},
			},
		});
	}
	moveElement('.benefitBanner', ['.product-section:first-of-type', '.product-section:last-of-type']);

	const benefitBanner = document.querySelector('.benefitBanner');

	if (benefitBanner) {
		const section = document.createElement('section');
		section.classList.add('benefit-section');
		const div = document.createElement('div');
		div.classList.add('container');
		const h2 = document.createElement('h2');
		h2.classList.add('homepage-group-title');
		h2.innerHTML = 'Proč si nás zamilujete';
		benefitBanner.parentNode.insertBefore(section, benefitBanner);
		div.appendChild(h2);
		div.appendChild(benefitBanner);
		section.appendChild(div);
	}
}
if (document.querySelector("body").classList.contains("id-763")) {
	if (window.innerWidth < 1120) {
		swiperize({
			containers: '.services-swiper',
			slide: '.block',
			customOptions: {
				fullscreen: false,
				infinity: false,
				dots: false,
				arrows: true,
				scrollbar: true,
				lazyPrevNext: true
			},
			swiperOptions: {
				direction: 'horizontal',
				speed: 800,
				spaceBetween: 16,
				slidesPerView: 2,
				breakpoints: {

					768: {
						slidesPerView: 5,
						spaceBetween: 16,
					},
					480: {
						slidesPerView: 3,
						spaceBetween: 16,
						autoplay: false
					}
				},
			},
		});
	}
}
const swiper1 = new Swiper(".review-swiper", {
	slidesPerView: 1,
	spaceBetween: 16,
	loop: false,
	scrollbar: {
		el: ".review-scrollbar",
		hide: false,
	},
	navigation: {
		nextEl: ".review-next",
		prevEl: ".review-prev",
	},
	breakpoints: {

		1024: {
			slidesPerView: 3,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		480: {
			slidesPerView: 1,
			spaceBetween: 16,
			autoplay: false
		}
	},
});
function addEmptySlides(selector, rules) {
	const swiperWrapper = document.querySelector(`${selector} .swiper-wrapper`);
	if (swiperWrapper) {
		rules.sort((a, b) => b.width - a.width);
		const applicableRule = rules.find(rule => window.innerWidth > rule.width);

		if (applicableRule) {
			for (let i = 0; i < applicableRule.emptySlidesCount; i++) {
				const emptySlide = document.createElement('div');
				emptySlide.classList.add('swiper-slide');
				swiperWrapper.appendChild(emptySlide);
			}
		}
	}
}

const swiper2 = new Swiper(".proud-off-swiper", {
	spaceBetween: 48,
	loop: false,
	slidesPerView: 1,
	speed: 800,
	scrollbar: {
		el: ".proud-off-scrollbar",
		hide: false,
	},
	navigation: {
		nextEl: ".proud-off-next",
		prevEl: ".proud-off-prev",
	},
	breakpoints: {
		900: {
			slidesPerView: 2,
		},
	},
});

// Definice pravidel pro přidání prázdných slidů
const rules = [
	{ width: 900, emptySlidesCount: 1 }
];

// Volání funkce s pravidly
addEmptySlides(".proud-off-swiper", rules);


const swiper3 = new Swiper(".store-1-swiper", {
	spaceBetween: 24,
	loop: false,
	slidesPerView: 1.2,
	speed: 800,
	watchSlidesProgress: true,
	scrollbar: {
		el: ".store-1-scrollbar",
		hide: false,
	},
	navigation: {
		nextEl: ".store-1-next",
		prevEl: ".store-1-prev",
	},
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		480: {
			slidesPerView: 2,
			spaceBetween: 24,
		}
	},
});


const swiper4 = new Swiper(".store-2-swiper", {
	// slidesPerView: 2.2,
	spaceBetween: 24,
	loop: false,
	slidesPerView: 1.2,
	// centeredSlides: true,
	speed: 800,
	watchSlidesProgress: true,
	scrollbar: {
		el: ".store-2-scrollbar",
		hide: false,
	},
	navigation: {
		nextEl: ".store-2-next",
		prevEl: ".store-2-prev",
	},
	initialSlide: document.querySelectorAll('.store-2-swiper .swiper-slide').length - 1, // Nastavení na poslední snímek
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween: 24,

		},
		768: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		480: {
			slidesPerView: 2,
			spaceBetween: 24,
		}
	},
});
if (shoptetPage === 'category') {
	moveElement('.specialni-dorty', ['#content-wrapper .content-wrapper-in', '#content-wrapper .category-top-wrapper']);
	moveElement('.faq-section', ['.specialni-dorty', '#content-wrapper .content-wrapper-in', '#content-wrapper .category-top-wrapper']);
}
on("click", ".question h3", function (e) {
	const content = this.closest(".question");
	this.classList.toggle("active");
	content.classList.toggle("active");
});

if (document.querySelector("body").classList.contains("id-763")) {
	moveElement('.faq-section', ['.our-offer', '.order-form', '.map-section', '.main-section']);
}

if (document.querySelector("body").classList.contains("id-766")) {
	moveElement('.faq-section', ['.contact-form-companies', '.side-img']);
}
// if (dataLayer[0].shoptet.pageType === 'homepage') handleHomepageProducts();

// const handleFooterBanners = () => {
// 	const footerBanners = document.querySelector('.footer-banners')
// 	const welcomeContainer = document.querySelector('.homepage-box.welcome-wrapper')
// 	if (footerBanners && welcomeContainer) {
// 		const footerBannersContainer = document.createElement('div')
// 		footerBannersContainer.classList.add('container', 'footer-banners-container')
// 		footerBannersContainer.appendChild(footerBanners)
// 		welcomeContainer.parentElement.insertBefore(footerBannersContainer, welcomeContainer.nextElementSibling)
// 	}
// }
// if (dataLayer[0].shoptet.pageType === 'homepage') handleFooterBanners()

// ANIMACE
let target = document.querySelectorAll('.products-block')
const target2 = document.querySelector('.top-categories-grid')
function handleIntersection(entries) {
	entries.map((entry, index) => {
		entry.target.style.removeProperty('--animation-delay')
		entry.target.setAttribute(
			'style',
			entry.target.getAttribute('style')
				? entry.target.getAttribute('style') + `--animation-delay: ${index}`
				: `--animation-delay: ${index}`
		)
		// entry.target.setAttribute('animation-delay', `${index}`)
		if (entry.isIntersecting) {
			entry.target.classList.add('visible')
		}
	})
}
const observer = new IntersectionObserver(handleIntersection)
const observer2 = new IntersectionObserver(handleIntersection)
if (target.length) {
	target.forEach((item) => {
		item.classList.add('animation')
		const subtargets = item.querySelectorAll('.product')
		subtargets.forEach((subtarget) => {
			observer.observe(subtarget)
		})
	})
}
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', () => {
	if (target.length) {
		target.forEach((item) => {
			item.classList.add('animation')
			const subtargets = item.querySelectorAll('.product')
			subtargets.forEach((subtarget) => {
				observer.observe(subtarget)
			})
		})
	}
})
if (target2) {
	target2.classList.add('animation')
	const subtargets = target2.querySelectorAll('.category')
	subtargets.forEach((subtarget) => {
		observer2.observe(subtarget)
	})
}





const handleCustomDetail = () => {
	// Najít .basic-description a obalit obsah divem .content-wrapper kromě prvního <h3>
	const basicDescription = document.querySelector('.basic-description');
	if (basicDescription) {
		const h3 = basicDescription.querySelector('h3');
		const contentWrapper = document.createElement('div');
		contentWrapper.classList.add('content-wrapper');

		while (basicDescription.firstChild) {
			if (basicDescription.firstChild !== h3) {
				contentWrapper.appendChild(basicDescription.firstChild);
			} else {
				basicDescription.removeChild(h3);
			}
		}

		if (h3) {
			basicDescription.insertBefore(h3, basicDescription.firstChild);
		}
		basicDescription.appendChild(contentWrapper);
	}

	// Najít .extended-description .detail-parameters a přidat třídu .content-wrapper
	const detailParameters = document.querySelector('.extended-description .detail-parameters');
	if (detailParameters) {
		detailParameters.classList.add('content-wrapper');

		// Vytvoření elementu <h4>
		const h4Element = document.createElement('h6');
		h4Element.innerText = 'Popis produktu';

		// Přidání elementu <h4> na první místo v content-wrapper
		detailParameters.insertAdjacentElement('afterbegin', h4Element);
	}

	// Najít #productVideos iframe a přidat třídu .content-wrapper
	const productVideosIframe = document.querySelector('#productVideos iframe');
	if (productVideosIframe) {
		productVideosIframe.classList.add('content-wrapper');
	}

	// Najít #ratingTab a obalit obsah divem .content-wrapper kromě prvního <h3>
	const ratingTab = document.querySelector('#ratingTab');
	if (ratingTab) {
		const h3 = ratingTab.querySelector('h3');
		const contentWrapper = document.createElement('div');
		contentWrapper.classList.add('content-wrapper');

		while (ratingTab.firstChild) {
			if (ratingTab.firstChild !== h3) {
				contentWrapper.appendChild(ratingTab.firstChild);
			} else {
				ratingTab.removeChild(h3);
			}
		}

		if (h3) {
			ratingTab.insertBefore(h3, ratingTab.firstChild);
		}
		ratingTab.appendChild(contentWrapper);
	}

	// Najít #productDiscussion #discussionWrapper a přidat třídu .content-wrapper
	const discussionWrapper = document.querySelector('#productDiscussion #discussionWrapper');
	if (discussionWrapper) {
		discussionWrapper.classList.add('content-wrapper');
	}
}

if (shoptetPage === 'productDetail') handleCustomDetail();






// if (shoptetPage === "homepage") {
// 	const newsWrapper = document.querySelector(".news-section .news-holder");
// 	const url = "/blog";
// 	if (newsWrapper) {
// 		fetch(url)
// 			.then((response) => {
// 				if (!response.ok) {
// 					throw new Error(`Něco není v pořádku: ${response.statusText}`);
// 				}
// 				return response.text();
// 			})
// 			.then((data) => {
// 				const tempContainer = document.createElement("div");
// 				tempContainer.innerHTML = data;

// 				const newsItems = tempContainer.querySelectorAll(".news-item");
// 				const firstThreeNewsItems = Array.from(newsItems).slice(0, 5);

// 				firstThreeNewsItems.forEach((newsItem) => {
// 					const titleElement = newsItem.querySelector(".text .title");
// 					const title = titleElement.textContent.trim();
// 					const link = titleElement.getAttribute("href");

// 					const timeElement = newsItem.querySelector(".text time");
// 					const timeHTML = timeElement ? `<time datetime="${timeElement.getAttribute("datetime")}">${timeElement.textContent.trim()}</time>` : "";


// 					const imageElement = newsItem.querySelector(".image img");
// 					const imageSrc = imageElement ? imageElement.getAttribute("src") : "";
// 					const imageDataSrc = imageElement ? imageElement.getAttribute("data-src") : "";
// 					const descriptionElement = newsItem.querySelector(".description");
// 					const readMore = newsBtnText.find(item => item.language === shoptetLang)?.text;

// 					const linkHTML = `<a href="${link}" class='show-more'>${readMore}</a>`;
// 					descriptionElement.textContent = linkHTML;


// 					const newNewsItem = document.createElement("div");
// 					newNewsItem.classList.add("news-item");
// 					newNewsItem.innerHTML = `
//                           <div class="image">
//                               ${imageSrc
// 							? `<a href="${link}" title="${title}"><img src="${imageDataSrc}" data-src="${imageDataSrc}" alt="${title}"></a>`
// 							: ""
// 						}
//                           </div>
//                           <div class="text"> 

//                               <a href="${link}" class="title">
//                                   ${title}
//                               </a>
// 							 ${timeHTML}
// 							 ${linkHTML}

//                           </div>
//                       `;

// 					newsWrapper.appendChild(newNewsItem);
// 				});

// 				// if (window.innerWidth < 900) {
// 				// 	$(newsWrapper).slick(newsSlickSettings)
// 				// }
// 				// window.addEventListener('resizeEnd', () => {
// 				// 	if (window.innerWidth < 900) {
// 				// 		if (newsWrapper.classList.contains('slick-initialized')) return
// 				// 		$(newsWrapper).slick(newsSlickSettings)
// 				// 	} else {
// 				// 		if (!newsWrapper.classList.contains('slick-initialized')) return
// 				// 		$(newsWrapper).slick('unslick')
// 				// 	}
// 				// })
// 			})
// 			.catch((error) => {
// 				console.error("Error:", error);
// 			});
// 	}
// };

// if (window.innerWidth < 900) {
// 	$(".carousel-cat").slick(newsSlickSettings)

// 	const secondDescription = document.querySelector('.category__secondDescription');
// 	if (secondDescription) {
// 		const carouselCat = document.querySelector('.carousel-cat');
// 		if (carouselCat) {
// 			const showMoreBtn = document.createElement('span');
// 			showMoreBtn.className = 'show-more';
// 			showMoreBtn.textContent = 'Číst dále';
// 			showMoreBtn.style.cursor = 'pointer';

// 			carouselCat.before(showMoreBtn);

// 			const paragraphs = secondDescription.querySelectorAll('p:not(.carousel-cat)');
// 			paragraphs.forEach((p, index) => {
// 				if (index === 0) { // Apply special styling to the first paragraph
// 					p.style.height = '110px';
// 					p.style.overflow = 'hidden';
// 				} else {
// 					p.style.display = 'none'; // Hide other paragraphs
// 				}
// 			});

// 			showMoreBtn.addEventListener('click', function () {
// 				this.style.display = 'none';

// 				paragraphs.forEach((p, index) => {
// 					if (index === 0) {
// 						p.style.height = ''; // Remove special styling from the first paragraph
// 					}
// 					p.style.display = 'block'; // Show all paragraphs
// 					p.style.overflow = '';
// 				});
// 			});
// 		}
// 	}
// }





if (window.innerWidth < 768) {
	const topNavigationBarMenu = document.querySelector('.top-navigation-bar-menu');
	const navigationIn = document.querySelector('#navigation .navigation-in');

	if (topNavigationBarMenu && navigationIn) {
		navigationIn.appendChild(topNavigationBarMenu);
	}
}

// const moveBenefitBanner = () => {
// 	const benefitBanner = document.querySelector('.benefitBanner')
// 	const footer = document.querySelector('#footer')

// 	if (benefitBanner && footer) {
// 		if (shoptetPage === 'homepage') {

// 		}
// 		footer.parentNode.insertBefore(benefitBanner, footer)
// 	}
// }

// moveBenefitBanner()
// document.addEventListener('ShoptetDOMPageContentLoaded', moveBenefitBanner)
// document.addEventListener('ShoptetDOMContentLoaded', moveBenefitBanner)

//Hodnocení obchodu

// const url = '/hodnoceni-obchodu';
// if (shoptetPage === "homepage") {

// 	function createSec() {
// 		const section = document.createElement('section');
// 		section.className = 'shop-review';
// 		return section;
// 	}

// 	const shopReview = createSec();

// 	const move1 = document.querySelector('.side-img.third');
// 	const move2 = document.querySelector('.faq-section');
// 	const move3 = document.querySelector('.chill-deliver');
// 	const move4 = document.querySelector('.middle-banners-wrapper') || document.querySelector('.body-banners');
// 	const move5 = document.querySelector('#footer');

// 	if (move1) {
// 		move1.insertAdjacentElement('afterend', shopReview);
// 	} else if (move2) {
// 		move2.insertAdjacentElement('afterend', shopReview);
// 	} else if (move3) {
// 		move3.insertAdjacentElement('afterend', shopReview);
// 	} else if (move4) {
// 		move4.insertAdjacentElement('afterend', shopReview);
// 	} else if (move5) {
// 		move5.insertAdjacentElement('beforebegin', shopReview);
// 	} else {
// 		console.error('Nic nenalezeno');
// 	}

// 	const container = document.createElement('div');
// 	container.classList.add('container');
// 	shopReview.appendChild(container);

// 	const flexHolder = document.createElement('div');
// 	flexHolder.classList.add('flex-holder');
// 	container.appendChild(flexHolder);

// 	const h2 = document.createElement('h2');
// 	const langTitle = hodnoceniNadpis.find(item => item.language === shoptetLang);
// 	if (langTitle) {
// 		h2.innerHTML = langTitle.text;
// 	}

// 	const votes = document.createElement('div');
// 	votes.classList.add('votes-wrap');

// 	// h2.innerHTML = hodnoceniNadpus;

// 	// const btnBlock = document.createElement('div');
// 	// btnBlock.classList.add('holder');
// 	// flexHolder.appendChild(btnBlock);
// 	const btn = document.createElement('a');
// 	btn.classList.add('btn', 'btn-secondary');
// 	btn.href = url;
// 	const langObject = recenzeBtnText.find(item => item.language === shoptetLang);
// 	if (langObject) {
// 		btn.innerHTML = langObject.text;
// 	}
// 	flexHolder.appendChild(h2);
// 	flexHolder.appendChild(votes);
// 	flexHolder.appendChild(btn);
// 	// const votesWrap = document.createElement('div');
// 	// votesWrap.classList.add('votes-wrap');
// 	// flexHolder.appendChild(votesWrap);
// 	if (url) {
// 		if (shopReview) {

// 			fetch(url)
// 				.then((response) => {
// 					if (!response.ok) {
// 					}
// 					return response.text();
// 				})
// 				.then((data) => {
// 					const tempContainer = document.createElement("div");
// 					tempContainer.innerHTML = data;

// 					const newsItems = tempContainer.querySelectorAll(".vote-wrap");
// 					const firstThreeNewsItems = Array.from(newsItems).slice(0, 3);

// 					firstThreeNewsItems.forEach((item, index) => {
// 						const initials = item.querySelector(".vote-initials").innerText;
// 						const imageSrc = item.querySelector(".vote-pic img").getAttribute("src");
// 						const name = item.querySelector(".vote-name span").innerText;
// 						const desc = item.querySelector(".vote-content").innerText;
// 						const voteTime = item.querySelector(".vote-time").innerText; // Added line to find vote-time
// 						const newItem = document.createElement("div");

// 						newItem.classList.add("vote-wrap");

// 						const starsContainer = document.createElement("span");
// 						starsContainer.classList.add("stars", 'data-testid="gridStars"');

// 						const existingStars = item.querySelectorAll(".stars .star");
// 						existingStars.forEach((existingStar) => {
// 							const starClass = existingStar.classList.contains("star-on") ? "star-on" : "star-off";
// 							const newStar = document.createElement("span");
// 							newStar.classList.add("star", starClass);
// 							starsContainer.appendChild(newStar);
// 						});

// 						// Additional code to handle the rest of the newItem construction would go here



// 						newItem.innerHTML = `

// 							 <div class="vote-header">
// 								<span class="vote-pic">
// 									<span class="vote-initials" >${initials}</span>
// 									<img src="${imageSrc}" data-src="//www.gravatar.com/avatar/2596fabc8f95f713744e85bda73a96e4?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar autora">
// 								</span>
// 								<span class="vote-summary">
// 									<span class="vote-name"><span>${name}</span></span>
// 									<span class="vote-rating">
// 									${starsContainer.outerHTML}
// 									<span class="vote-time" data-testid="latestContributionDate">
// 									${voteTime}
//                 					</span>
// 									</span>

// 								</span>
// 							</div>
// 							<div class="vote-content" data-testid="textRating">${desc}</div>
// 					`;

// 						// Strídačka mezi .left a .right

// 						votes.appendChild(newItem);

// 					});

// 					// $('.shop-review .votes-wrap').slick({
// 					// 	arrows: false, // No arrows
// 					// 	dots: false, // No dots
// 					// 	infinite: false,
// 					// 	slidesToShow: 3,
// 					// 	slidesToScroll: 1,
// 					// 	variableWidth: true // Enable variable width for slides
// 					// });
// 					swiperize({
// 						containers: '.votes-wrap',
// 						slide: '.vote-wrap',
// 						customOptions: {
// 							fullscreen: false,
// 							infinity: true,
// 							dots: false,
// 							arrows: true,
// 							scrollbar: false,
// 							lazyPrevNext: true
// 						},
// 						swiperOptions: {
// 							direction: 'horizontal',
// 							speed: 800,
// 							spaceBetween: 24,
// 							slidesPerView: 3,
// 							breakpoints: {
// 								1200: {
// 									slidesPerView: 3,
// 									spaceBetween: 24,
// 								},
// 								768: {
// 									slidesPerView: 2,
// 									spaceBetween: 16,
// 								},
// 								0: {
// 									slidesPerView: 1,
// 									spaceBetween: 16,
// 								}
// 							},
// 						},
// 					});
// 				})
// 				.catch((error) => {
// 					console.error("Error:", error);
// 				});
// 		};
// 	}

// }


// setTimeout(function () {

// }, 1000);



$(document).on("click", ".shp-tab-link", function (e) {
	var target = $(this).attr("href");
	if ($(target).length > 0) {
		e.preventDefault();
		$("html,body").animate({
			scrollTop: $(target).offset().top - 150
		}, 700);
	}
});

//Měnící se placeholder v search inputu

document.addEventListener('DOMContentLoaded', () => {
	const searchInput = document.querySelector('.search input[type="search"]');
	const placeholders = ["Dorty", "Zákusky", "Makronky"];
	let currentPlaceholderIndex = 0;
	let currentCharIndex = 0;
	let intervalId;
	let isDeleting = false;

	function updatePlaceholder() {
		if (searchInput !== document.activeElement && searchInput.value === '') {
			if (!isDeleting) {
				if (currentCharIndex === 0) {
					searchInput.placeholder = '';
				}
				if (currentCharIndex < placeholders[currentPlaceholderIndex].length) {
					searchInput.placeholder += placeholders[currentPlaceholderIndex].charAt(currentCharIndex);
					currentCharIndex++;
				} else {
					clearInterval(intervalId);
					setTimeout(() => {
						isDeleting = true;
						intervalId = setInterval(updatePlaceholder, 100);
					}, 3000);
				}
			} else {
				if (currentCharIndex > 0) {
					searchInput.placeholder = searchInput.placeholder.slice(0, -1);
					currentCharIndex--;
				} else {
					clearInterval(intervalId);
					setTimeout(() => {
						isDeleting = false;
						currentPlaceholderIndex = (currentPlaceholderIndex + 1) % placeholders.length;
						intervalId = setInterval(updatePlaceholder, 100);
					}, 1000);
				}
			}
		}
	}

	searchInput.addEventListener('focus', () => {
		clearInterval(intervalId);
	});

	searchInput.addEventListener('blur', () => {
		intervalId = setInterval(updatePlaceholder, 100);
	});

	intervalId = setInterval(updatePlaceholder, 100);
});




//Swiper na naposledy prohlížené produkty

// document.addEventListener('DOMContentLoaded', () => {
//     const observer = new MutationObserver((mutationsList, observer) => {
//         for (const mutation of mutationsList) {
//             if (mutation.type === 'childList') {
//                 const lastViewedProducts = document.querySelector('.dvpnProducts');
//                 const instagramSection = document.querySelector('.custom-footer__instagram');
//                 if (lastViewedProducts && instagramSection) {
//                     const visitedProductsContainer = lastViewedProducts.closest('.dkLabVisitedProductsNew');
//                     if (visitedProductsContainer) {
//                         // Vytvoření nového divu s třídou container
//                         const containerDiv = document.createElement('div');
//                         containerDiv.classList.add('container');

//                         // Přesunutí dkLabVisitedProductsNew do nového divu
//                         containerDiv.appendChild(visitedProductsContainer);

//                         // Přesunutí nového divu před custom-footer__instagram
//                         instagramSection.parentNode.insertBefore(containerDiv, instagramSection);

//                         // Inicializace swiperize
//                         swiperize({
//                             containers: '.dvpnProducts',
//                             slide: '.dvpnProducts__item',
//                             customOptions: {
//                                 fullscreen: false,
//                                 infinity: true,
//                                 dots: true,
//                                 arrows: true,
//                                 scrollbar: false,
//                                 lazyPrevNext: true
//                             },
//                             swiperOptions: {
//                                 direction: 'horizontal',
//                                 speed: 800,
//                                 spaceBetween: 25,
//                                 slidesPerView: 5,
//                                 breakpoints: {
//                                     1440: {
//                                         slidesPerView: 5,
//                                         spaceBetween: 25,
//                                     },
//                                     1200: {
//                                         slidesPerView: 4,
//                                         spaceBetween: 16,
//                                     },
//                                     993: {
//                                         slidesPerView: 3,
//                                         spaceBetween: 16,
//                                     },
//                                     500: {
//                                         slidesPerView: 2,
//                                         spaceBetween: 16,
//                                     },
//                                     0: {
//                                         slidesPerView: 1.25,
//                                         spaceBetween: 16,
//                                         autoplay: false
//                                     }
//                                 },
//                             },
//                         });
//                         observer.disconnect();
//                         break;
//                     }
//                 }
//             }
//         }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });

on("click", ".f-field-group label", function (e) {
	const clossest = this.closest('.f-field-group');
	const input = clossest.querySelector('input');
	input.style.display = 'block';
});